import { useEffect, useState } from "react";

interface UseAsync<T> {
  response?: T;
  loading: boolean;
  error: boolean;
}
export function useAsync<T>(
  promise: () => Promise<T>,
  deps: any[] = [],
  mock?: T
): UseAsync<T> {
  const [response, setResponse] = useState<T>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true);

    promise()
      .then((data: T) => setResponse(data))
      .catch((e) => {
        console.log(e);
        setError(true);
      })
      .finally(() => setLoading(false));
  }, deps);

  if (mock) return { response: mock, loading: false, error: false };
  return { response, loading, error };
}
